module.exports = __webpack_public_path__ + "img/Bingo_Info_Game5.d89fa637.png";